// extracted by mini-css-extract-plugin
export default {"productCarousel":"O3-z"};